export default "__VITE_ASSET__CSGWrMeS__"